import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ProjectPickerModal from './ProjectPickerModal';

const toOption = project => ({
  label: project.label ?? project.name,
  value: project.value ?? project.id,
});

const ProjectTargetField = ({
  defaultProjectId,
  initialNextPage = null,
  initialProjects = [],
  inputProps = {},
  name = 'project_id',
  onChange,
}) => {
  const projectOptions = useMemo(() => initialProjects.map(toOption), [initialProjects]);
  const defaultProject = projectOptions.find(project => project.value === defaultProjectId) ?? {
    label: 'Current project',
    value: defaultProjectId,
  };
  const [selectedProject, setSelectedProject] = useState(defaultProject);
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const confirmProject = project => {
    setSelectedProject(project);
    onChange?.(project);
    setIsPickerOpen(false);
  };

  return (
    <>
      <input type="hidden" name={name} value={selectedProject?.value ?? ''} readOnly {...inputProps} />
      <div className="form-control w-full">
        <div className="label">
          <span className="label-text">Project</span>
        </div>
        <div className="flex items-center justify-between gap-3 rounded border border-gray-200 px-3 py-2">
          <span className="min-w-0 truncate text-sm text-gray-700">{selectedProject?.label ?? 'Select a project'}</span>
          <button type="button" className="btn btn-secondary btn-xs" onClick={() => setIsPickerOpen(true)}>
            Change
          </button>
        </div>
      </div>
      {isPickerOpen && (
        <ProjectPickerModal
          initialNextPage={initialNextPage}
          initialProjects={initialProjects}
          onClose={() => setIsPickerOpen(false)}
          onConfirm={confirmProject}
          open={isPickerOpen}
          selectedProject={selectedProject}
        />
      )}
    </>
  );
};

ProjectTargetField.propTypes = {
  defaultProjectId: PropTypes.string,
  initialNextPage: PropTypes.string,
  initialProjects: PropTypes.arrayOf(PropTypes.object),
  inputProps: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

export default ProjectTargetField;
